import { ReactNode } from "react";
import { IconType } from "react-icons";

interface DetailsItemProps {
  label: string;
  value?: string | ReactNode;
  disabled?: boolean;
  status?: "pending" | "activated" | "suspended";
  icon?: IconType;
  copyable?: boolean;
}

export const DetailsItem = ({
  label,
  value,
  disabled,
  status,
}: DetailsItemProps) => {
  const getStatusStyles = (status?: string) => {
    switch (status) {
      case "pending":
        return "bg-yellow-100 text-amber-700 border-amber-300";
      case "activated":
        return "bg-green-100 text-emerald-700 border-emerald-300";
      case "suspended":
        return "bg-red-100 text-rose-700 border-rose-300";
      default:
        return "bg-indigo-100/20 border-indigo-200";
    }
  };

  return (
    <div className="w-full">
      <p className="text-gray-500 text-sm">{label}</p>
      <div
        className={`rounded-md p-2 border w-full min-h-[40px] flex items-center justify-between ${getStatusStyles(
          status
        )} ${disabled ? "opacity-80" : ""}`}
      >
        <span>{value || <span className="text-gray-400">N/A</span>}</span>
      </div>
    </div>
  );
};
